import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

import { salesCadenceMessages } from './salesCadenceMessages';

export const helpCadastrarEstoque: ISidebarHelp = {
	title: salesCadenceMessages.SCREEN_TITLES.SALES_CADENCE,
	firstParagraph: salesCadenceMessages.MSG_PROJECTION_GUIDANCE,
	firstLink: URL_CT360,
	secondLink: URL_FALE_CONOSCO,
};
